import { render } from "./FamilyOfficePage.vue?vue&type=template&id=591c0db2"
import script from "./FamilyOfficePage.vue?vue&type=script&lang=js"
export * from "./FamilyOfficePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__